import type { ReactNode } from 'react'

import clsx from 'clsx'

import { PageMeta } from '@/shared/lib/meta/page-meta'

import { PageBackButton } from './PageBackButton'

type PageHeaderProps = {
  className?: string
  title: string
  /** Destino do voltar. Omitido = home (`/`). */
  backHref?: string
  /** Ilustração decorativa à direita do título (ex.: sorteios). */
  art?: string
  actions?: ReactNode
}

export const PageHeader = ({
  className,
  title,
  backHref,
  art,
  actions
}: PageHeaderProps) => {
  const titleBlock = (
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <h1 className="m-0 text-lg font-bold leading-tight text-gray-900">
        {title}
      </h1>
    </div>
  )

  return (
    <>
      <PageMeta title={title} />
      <div className={clsx('flex items-center gap-3 pt-3 pb-2', className)}>
        <PageBackButton variant="surface" backHref={backHref} />
        {titleBlock}
        {art ? (
          <img
            src={art}
            alt=""
            className="h-[5.25rem] w-[6.5rem] shrink-0 object-contain sm:h-[6.25rem] sm:w-[7.75rem]"
            aria-hidden
          />
        ) : actions ? (
          <div className="flex shrink-0 items-center">{actions}</div>
        ) : null}
      </div>
    </>
  )
}
